import React from "react";
import Select from "react-select";
import { CDBBtn } from 'cdbreact';

export const ModalSkus = ({ action, setPressedButton, formData, handleChange, providers, articleTypes, categories }) => {

  const providerSelect = providers.map((provider) => ({
    value: provider.Nit,
    label: `Código Proveedor: ${provider.Nit} / Nombre del proyecto: ${provider.ProjectName}`,
  }));

  const articleTypeSelect = articleTypes ? articleTypes.map((type) => ({
    value: type.name,
    label: type.name,
  })) : [];

  const categorySelect = categories ? categories.map((category) => ({
    value: category.name,
    label: category.name,
  })) : [];

  const unitOptions = [
    { value: "Und", label: "Unidad" },
    { value: "m", label: "Metros" },
    { value: "cm", label: "Centímetros" },
    { value: "ml", label: "Mililitros" },
    { value: "in", label: "Pulgadas" },
    { value: "oz", label: "Onzas" },
    { value: "L", label: "Litros" },
    { value: "gal", label: "Galones" },
    { value: "g", label: "Gramos" },
    { value: "kg", label: "Kilogramos" },
  ];

  const showStatusOptions = [
    { value: "MTS", label: "MTS" },
    { value: "MTO", label: "MTO" },
  ];

  return (
    <div>
      <div className="modal-header">
        <div>
          <h3 className="modal-title" id="exampleModalLabel">
            {action === 'create' ? 'Crear un SKU' : 'Editando un SKU'}
          </h3>
        </div>
        {action === 'edit' && (
          <CDBBtn
            size="small"
            className="p-2 btn"
            color="danger"
            outline
            onClick={() => setPressedButton('delete')}
          >
            <i className="fas fa-trash"></i>
            Eliminar
          </CDBBtn>
        )}
      </div>
      <div className="modal-body">
        {action !== 'create' && (
          <div className="form-group">
            <label>Código SAP</label>
            <input
              type="text"
              className="form-control mb-4"
              id="CodeSap"
              placeholder="Código SAP"
              disabled
              value={formData.CodeSap}
              onChange={handleChange}
            />
          </div>
        )}
        {action !== 'edit' && (
          <div className="form-group">
            <label>Código SAP<span className="text-danger"> *</span></label>
            <input
              type="text"
              className="form-control mb-4"
              id="CodeSap"
              placeholder="Código SAP"
              value={formData.CodeSap}
              onChange={handleChange}
            />
          </div>
        )}
        <div className="form-group row mb-4">
          <div className="col">
            <label htmlFor="Nit">Código Proveedor:<span className="text-danger"> *</span></label>
            <Select
              id="Nit"
              isDisabled={action === 'edit'}
              placeholder="Código..."
              options={providerSelect}
              value={providerSelect.find(
                (option) => option.value === formData.Nit
              )}
              onChange={(selectedOption) =>
                handleChange({
                  target: {
                    value: selectedOption.value,
                    id: "Nit",
                  },
                })
              }
            />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="SkuDescription">Descripción:<span className="text-danger"> *</span></label>
          <textarea
            className="form-control mb-4"
            id="SkuDescription"
            placeholder="Descripción del SKU"
            value={formData.SkuDescription}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row mb-4">
          <div className="col">
            <label htmlFor="article_type">Tipo de Artículo:<span className="text-danger"> *</span></label>
            <Select
              id="article_type"
              placeholder="Seleccione un tipo de artículo"
              options={articleTypeSelect}
              value={articleTypeSelect.find((option) => option.value === formData.article_type)}
              onChange={(selectedOption) =>
                handleChange({
                  target: {
                    value: selectedOption ? selectedOption.value : "",
                    id: "article_type",
                  },
                })
              }
              isClearable
            />
          </div>
          <div className="col">
            <label htmlFor="category">Categoría:<span className="text-danger"> *</span></label>
            <Select
              id="category"
              placeholder="Seleccione una categoría"
              options={categorySelect}
              value={categorySelect.find((option) => option.value === formData.category)}
              onChange={(selectedOption) =>
                handleChange({
                  target: {
                    value: selectedOption ? selectedOption.value : "",
                    id: "category",
                  },
                })
              }
              isClearable
            />
          </div>
        </div>
        <div className="form-group row mb-4">
          <div className="col">
            <label htmlFor="show_status">MTS/MTO</label>
            <Select
              id="show_status"
              placeholder={formData.show_status == null ? "Sin proporcionar" : "Seleccione MTS o MTO"}
              options={showStatusOptions}
              value={showStatusOptions.find((option) => option.value === formData.show_status) || null}
              onChange={(selectedOption) =>
                handleChange({
                  target: {
                    value: selectedOption ? selectedOption.value : null,
                    id: "show_status",
                  },
                })
              }
              isClearable
            />
          </div>
        </div>
        <div className="form-group row mb-4">
          <label htmlFor="unit_type">Unidad de medida:<span className="text-danger"> *</span></label>
          <Select
            id="unit_type"
            placeholder="Seleccione una unidad de medida"
            options={unitOptions}
            value={unitOptions.find((option) => option.value.toUpperCase() === formData.unit_type.toUpperCase())}
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  value: selectedOption.value,
                  id: "unit_type",
                },
              })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="Rop">ROP:<span className="text-danger"> *</span></label>
          <input
            type="number"
            className="form-control mb-4"
            id="Rop"
            placeholder="ROP"
            step="0.01" // Permitir decimales
            value={formData.Rop}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="Inventory">Inventario:<span className="text-danger"> *</span></label>
          <input
            type="number"
            className="form-control mb-4"
            id="Inventory"
            placeholder="Inventario"
            step="0.01" // Permitir decimales
            value={formData.Inventory}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="modal-footer justify-content-center align-items-center">
        <CDBBtn
          type="button"
          color="danger"
          outline
          onClick={() => setPressedButton('closeModal')}
        >
          Cerrar
        </CDBBtn>
        <CDBBtn
          type="button"
          color="success"
          className="mr-auto"
          outline
          onClick={() => setPressedButton('submitModal')}
        >
          Guardar
        </CDBBtn>
      </div>
    </div>
  );
};